export  default {
    getManufacturers(state) {
        return state.manufacturers;
    },
    getCurrentManufacturer(state) {
        return state.currentManufacturer;
    },
};